import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/clinaddis.png';
import './Programs.css';

const Programs = () => {
  const programs = [
    {
      id: 1,
      title: "ClinAddis Innovation Lab",
      partner: "Ministry of Health",
      description: "A collaborative space for developing innovative healthcare solutions in partnership with the Ministry of Health. Focus on practical, scalable innovations that address Ethiopia's healthcare challenges.",
      icon: "🔬",
      slug: "innovation-lab"
    },
    {
      id: 2,
      title: "ClinAddis Skills & Leadership Program",
      partner: "U.S. Embassy",
      description: "Comprehensive training program focusing on leadership development, technical skills, and professional growth for healthcare professionals and students.",
      icon: "🎯",
      slug: "skills-leadership"
    },
    {
      id: 3,
      title: "Art & Medicine",
      partner: "Hilton",
      description: "A unique program exploring the intersection of healthcare and artistic expression. Using art as a tool for healing, communication, and medical education.",
      icon: "🎨",
      slug: "art-medicine"
    },
    {
      id: 4,
      title: "ClinAddis Community Connect",
      partner: "Chaka Coffee",
      description: "Community engagement initiative bringing healthcare discussions to public spaces. Creating accessible platforms for health education and awareness.",
      icon: "🤝",
      slug: "community-connect"
    },
    {
      id: 5,
      title: "ClinAddis Public Health Forum",
      partner: "Africa CDC",
      description: "Platform for discussing critical public health issues, policy recommendations, and collaborative solutions for Africa's healthcare challenges.",
      icon: "🌍",
      slug: "public-health-forum"
    },
    {
      id: 6,
      title: "ClinAddis Future Leaders",
      partner: "High Schools",
      description: "Volunteer program engaging high school students in healthcare innovation. Early exposure to medical careers and community health initiatives.",
      icon: "👨‍🎓",
      slug: "future-leaders"
    },
  ];

  return (
    <div className="programs-page">
      {/* Hero Section */}
      <section className="section hero-section programs-hero">
        <div className="container">
          <h1 className="text-center">Our Programs</h1>
          <p className="subtitle text-center">
            Transforming healthcare through innovative initiatives and strategic partnerships
          </p>
        </div>
      </section>

      {/* Program Introduction */}
<section className="section">
  <div className="container">
    <div className="programs-intro-grid">
      <div className="programs-intro-content">
        <h2 className="mb-4">Driving Healthcare in Ethiopia</h2>
        <p className="lead">
          At ClinAddis, we design and implement targeted programs that bridge gaps in healthcare delivery, 
          foster innovation, and build capacity across the healthcare ecosystem. Each program is developed 
          in partnership with leading organizations to maximize impact and sustainability.
        </p>
      </div>
      <div className="programs-intro-image">
        <img 
          src={logo} 
          alt="ClinAddis team working on healthcare innovation"
          className="intro-image"
        />
      </div>
    </div>
  </div>
</section>

      {/* Programs Grid */}
      <section className="section section-alt">
        <div className="container">
          <div className="text-center mb-5">
            <h2>Our Program Portfolio</h2>
            <p className="lead">Explore our diverse range of healthcare innovation initiatives</p>
          </div>

          <div className="programs-grid">
            {programs.map((program) => (
              <div key={program.id} className="program-card">
                <div className="program-icon">{program.icon}</div>
                <div className="program-number">0{program.id}</div>
                <h3>{program.title}</h3>
                <div className="program-partner">
                  <span className="partner-label">Partner:</span>
                  <span className="partner-name">{program.partner}</span>
                </div>
                <p className="program-description">{program.description}</p>
                <div className="program-cta">
                  <Link 
                    to={`/programs/${program.slug}`}
                    className="btn-program-details"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Rest of the component remains the same... */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-5">
            <h2>Program Categories</h2>
            <p className="lead">Our programs are organized into strategic focus areas</p>
          </div>

          <div className="categories-grid">
            <div className="category-card">
              <div className="category-icon">💡</div>
              <h4>Innovation & Research</h4>
              <p>Programs focused on developing new solutions and advancing healthcare research</p>
            </div>

            <div className="category-card">
              <div className="category-icon">👥</div>
              <h4>Community Engagement</h4>
              <p>Initiatives that connect healthcare with communities and public spaces</p>
            </div>

            <div className="category-card">
              <div className="category-icon">🎓</div>
              <h4>Capacity Building</h4>
              <p>Training and development programs for healthcare professionals</p>
            </div>
          </div>
        </div>
      </section>

      

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="text-center">
            <h2>Get Involved</h2>
            <p className="mb-4">Want to participate in or support our programs?</p>
            <div className="cta-buttons">
              <Link to="/join" className="btn btn-primary">Join Our Programs</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Programs;